var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackNavArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8067 4.92081H3.66443L6.75705 1.82819C7.17584 1.4094 7.17584 0.732886 6.75705 0.314094C6.33826 -0.104698 5.66174 -0.104698 5.24295 0.314094L0.314094 5.24295C-0.104698 5.66174 -0.104698 6.33826 0.314094 6.75705L5.24295 11.6859C5.66174 12.1047 6.33826 12.1047 6.75705 11.6859C7.17584 11.2671 7.17584 10.5906 6.75705 10.1718L3.66443 7.06846H16.8067C17.3973 7.06846 17.8805 6.58523 17.8805 5.99463C17.8805 5.40403 17.3973 4.92081 16.8067 4.92081Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNavArrow);
export default __webpack_public_path__ + "static/media/back-nav-arrow.0e297a9b4f2ad71db404ce652198cd44.svg";
export { ForwardRef as ReactComponent };